import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc"
  }
};
import { onBeforeUnmount, shallowRef } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
// TODO 须测试
import '@wangeditor/editor/dist/css/style.css'; 
import { ref, watch } from 'vue';
// 引入 css
const defaultEditorConfig = {
  placeholder: '请输入您需要发布的内容...',
  MENU_CONF: {
    uploadImage: {
      // 小于该值就插入 base64 格式（而不上传），默认为 0
      base64LimitSize: 1024 * 1024 // 5kb
    }
  }
};
const defaultToolbarConfig = {
  toolbarKeys: ['headerSelect',
  // '|',
  // 'header1',
  // 'header2',
  // 'header3',
  // 'header4',
  // 'header5',
  'bold', 'underline', 'italic', 'through',
  // 'code',
  // 'sub',
  // 'sup',
  // 'clearStyle',
  'color', 'bgColor', 'fontSize', 'fontFamily', 'indent', 'delIndent',
  // 'justifyLeft',
  // 'justifyRight',
  // 'justifyCenter',
  // 'justifyJustify',
  'lineHeight', 'insertImage', 'uploadImage',
  // 'deleteImage',
  // 'editImage',
  // 'viewImageLink',
  // 'imageWidth30',
  // 'imageWidth50',
  // 'imageWidth100',
  'divider',
  // 'emotion',
  'insertLink', 'editLink', 'unLink', 'viewLink', 'codeBlock', 'blockquote', 'todo', 'redo', 'undo', 'fullScreen'
  // 'enter',
  // 'bulletedList',
  // 'numberedList',
  // 'insertTable',
  // 'deleteTable',
  // 'insertTableRow',
  // 'deleteTableRow',
  // 'insertTableCol',
  // 'deleteTableCol',
  // 'tableHeader',
  // 'tableFullWidth',
  // 'insertVideo',
  // 'uploadVideo',
  // 'editVideoSize',
  // 'uploadImage',
  // 'codeSelectLang',
  ]
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {},
    editorConfig: {
      default: () => {
        return defaultEditorConfig;
      }
    },
    toolbarConfig: {
      default: () => {
        return defaultToolbarConfig;
      }
    },
    height: {
      default: '300px'
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef();
    const mode = ref('default');
    const valueHtml = ref(props.modelValue);
    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });
    const handleCreated = editor => {
      editorRef.value = editor; // 记录 editor 实例，重要！
      editor.setHtml(valueHtml.value);
      console.log('editor', editor);
      console.log(editor.getAllMenuKeys());
    };
    watch(() => props.modelValue, newValue => {
      if (newValue !== valueHtml.value) {
        valueHtml.value = newValue;
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(() => valueHtml.value, newValue => {
      emit('update:modelValue', newValue);
    });
    const getHtml = () => {
      return editorRef.value ? editorRef.value.getHtml() : undefined;
    };
    __expose({
      getHtml
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
        style: {
          "border-bottom": "1px solid #ccc"
        },
        editor: editorRef.value,
        defaultConfig: _ctx.toolbarConfig,
        mode: _unref(mode)
      }, null, 8, ["editor", "defaultConfig", "mode"]), _createVNode(_unref(Editor), {
        style: _normalizeStyle([{
          "overflow-y": "hidden"
        }, {
          height: _ctx.height
        }]),
        modelValue: _unref(valueHtml),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(valueHtml) ? valueHtml.value = $event : null),
        defaultConfig: _ctx.editorConfig,
        mode: _unref(mode),
        onOnCreated: handleCreated
      }, null, 8, ["style", "modelValue", "defaultConfig", "mode"])]);
    };
  }
});